#import "@/apollo/fragments/Campaign.gql"

mutation AddCampaign($clientId: ID!, $campaign: InputCampaign!) {
    addCampaign(clientId: $clientId, campaign: $campaign) {
        ...Campaign
        client {
            _id
            id
        }
    }
}
